/*
 * OOO Header controller (loaded globally, deferred).
 *  - <ooo-marquee>: seamless infinite announce bar (skill §9). Fills one
 *    half to >= viewport, duplicates the track, normalizes speed to width.
 *  - Mobile hamburger: toggles the collapsible nav drawer.
 *  - Shop mega-dropdown: hover on desktop; tap-to-toggle on touch/mobile.
 *  - Search overlay: opens the top drawer, live-filters the dropdown
 *    catalog cards into the results grid. No live products required.
 *  - Cart icon -> window.OOOCart.open() (defined in ooo-cart.js).
 *  - Esc / scrim close everything.
 */

/* ── Marquee custom element (skill §9) ───────────────────── */
if (!customElements.get('ooo-marquee')) {
  class OOOMarquee extends HTMLElement {
    connectedCallback() {
      var track = this.querySelector('[data-ooo-marquee-track]');
      if (!track || track.dataset.cloned === 'true') return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        track.dataset.cloned = 'true';
        return;
      }
      var originals = Array.prototype.slice.call(track.children);
      var append = function (node) {
        var clone = node.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      };
      // 1) fill one set to >= viewport so the -50% loop never gaps
      var guard = 0;
      while (track.scrollWidth < this.offsetWidth && guard < 40) {
        originals.forEach(append);
        guard++;
      }
      var halfWidth = track.scrollWidth;
      // 2) duplicate the whole filled track once -> two identical halves
      Array.prototype.slice.call(track.children).forEach(append);
      track.dataset.cloned = 'true';
      // 3) constant ~70px/sec speed regardless of clone count
      track.style.animationDuration = Math.max(18, Math.round(halfWidth / 70)) + 's';
    }
  }
  customElements.define('ooo-marquee', OOOMarquee);
}

(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    var header = document.querySelector('[data-ooo-header]');
    if (!header) return;

    var scrim = header.querySelector('[data-ooo-scrim]');
    var search = header.querySelector('[data-ooo-search]');
    var searchInput = header.querySelector('[data-ooo-search-input]');
    var searchResults = header.querySelector('[data-ooo-search-results]');
    var searchLabel = header.querySelector('[data-ooo-search-label]');
    var catalog = header.querySelector('[data-ooo-catalog]');
    var defaultLabel = searchLabel ? searchLabel.textContent : 'Popular right now';

    /* ── Sticky offset for the search overlay (skill §6) ──
       Search overlay is fixed at top:0; on desktop nudge it below the
       sticky header so it doesn't cover the nav. */
    function setSearchTop() {
      if (!search) return;
      var hg = document.querySelector('#header-group');
      if (hg && window.matchMedia('(min-width: 1025px)').matches) {
        search.style.setProperty('--ooo-search-top', hg.offsetHeight + 'px');
      } else {
        search.style.setProperty('--ooo-search-top', '0px');
      }
    }
    setSearchTop();
    window.addEventListener('resize', setSearchTop);

    /* ── Mobile hamburger ── */
    var burger = header.querySelector('[data-ooo-menu-toggle]');
    if (burger) {
      burger.addEventListener('click', function () {
        var open = header.dataset.oooOpen === 'true';
        header.dataset.oooOpen = String(!open);
        burger.setAttribute('aria-expanded', String(!open));
      });
    }

    /* ── Shop dropdown: tap-to-toggle on touch / mobile ── */
    Array.prototype.slice.call(header.querySelectorAll('[data-ooo-shop]')).forEach(function (li) {
      var trigger = li.querySelector('[data-ooo-shop-trigger]');
      if (!trigger) return;
      trigger.addEventListener('click', function (e) {
        if (window.matchMedia('(max-width: 1024px)').matches) {
          e.preventDefault();
          li.classList.toggle('is-open');
        }
      });
    });

    /* ── Search overlay ── */
    function openSearch() {
      if (!search) return;
      closePanels();
      setSearchTop();
      search.classList.add('is-open');
      search.setAttribute('aria-hidden', 'false');
      if (scrim) scrim.classList.add('is-open');
      renderSearch('');
      setTimeout(function () { if (searchInput) searchInput.focus(); }, 120);
    }
    function closeSearch() {
      if (!search) return;
      search.classList.remove('is-open');
      search.setAttribute('aria-hidden', 'true');
    }
    function closePanels() {
      closeSearch();
      Array.prototype.slice.call(header.querySelectorAll('.ooo-shop.is-open'))
        .forEach(function (el) { el.classList.remove('is-open'); });
    }
    function closeAll() {
      closePanels();
      if (scrim) scrim.classList.remove('is-open');
    }

    // Clone catalog cards into the search results, filtered by query.
    function renderSearch(q) {
      if (!searchResults || !catalog) return;
      q = (q || '').trim().toLowerCase();
      var cards = Array.prototype.slice.call(catalog.querySelectorAll('[data-ooo-product]'));
      var matches = cards.filter(function (c) {
        if (!q) return true;
        var hay = (c.dataset.name + ' ' + (c.dataset.kw || '')).toLowerCase();
        return hay.indexOf(q) > -1;
      });
      if (searchLabel) searchLabel.textContent = q ? (matches.length ? 'Results' : '') : defaultLabel;
      searchResults.innerHTML = '';
      if (!matches.length) {
        if (q) {
          var p = document.createElement('p');
          p.className = 'ooo-search__empty';
          p.textContent = 'No matches for “' + q + '”. Try “sleep”, “calm”, “focus”…';
          searchResults.appendChild(p);
        }
        return;
      }
      matches.forEach(function (c) {
        var clone = c.cloneNode(true);
        clone.removeAttribute('data-ooo-product');
        searchResults.appendChild(clone);
      });
    }

    Array.prototype.slice.call(header.querySelectorAll('[data-ooo-search-open]'))
      .forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); openSearch(); }); });
    var searchClose = header.querySelector('[data-ooo-search-close]');
    if (searchClose) searchClose.addEventListener('click', closeSearch);
    if (searchInput) searchInput.addEventListener('input', function () { renderSearch(searchInput.value); });

    /* ── Cart icon -> OOOCart.open() (ooo-cart.js) ── */
    Array.prototype.slice.call(header.querySelectorAll('[data-ooo-cart-open]'))
      .forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault();
          if (window.OOOCart && window.OOOCart.open) window.OOOCart.open();
        });
      });

    /* ── Scrim + Esc close everything ── */
    if (scrim) scrim.addEventListener('click', closeAll);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
  });
})();
